import { Marquee, loop } from 'dynamic-marquee';

const createMarqueeItem = (text) => {
  const $item = document.createElement('div');
  $item.innerHTML = text;
  return $item;
};

const marqueeComponent = (message) => {
  const marqueeElement = document.querySelector('.js-marquee');

  if (marqueeElement != null) {
    const marquee = new Marquee(marqueeElement, {
      rate: -100,
    });

    // Build marquee messages  - replace with tweets later
    const $mqmessage = document.createElement('div');
    $mqmessage.innerHTML = message;

    // Create marquee items (as seen on https://www.npmjs.com/package/dynamic-marquee)
    marquee.appendItem($mqmessage);

    // Define the loop function that generates new marquee items
    const loopFunction = () => {
      const $newItem = createMarqueeItem(message);
      return $newItem;
    };

    // Start the loop and specify the marquee and loopFunction
    const { update } = loop(marquee, [loopFunction]);

    // Optionally, you can set an interval to update the loop at a specific rate
    const loopUpdateInterval = 5000; // Update every 5 seconds
    setInterval(() => {
      update([loopFunction]);
    }, loopUpdateInterval);
  }
};

export default marqueeComponent;
